// extracted by mini-css-extract-plugin
export default {"row":"AccrualPeriodFormCompensation_row__ryEDl","placeHolderShimmer":"AccrualPeriodFormCompensation_placeHolderShimmer__XgEho"};